import { FIELD_BASE_CLASS, fieldBorderClass } from '@/components/base/shared-classes';

export interface SelectOption {
  value: string;
  label: string;
}

export interface SelectProps {
  uiId: string;
  value: string;
  onChange: (next: string) => void;
  options: readonly SelectOption[];
  disabled?: boolean;
  invalid?: boolean;
  /** 有值時在最前面插入一個 value="" 的提示項（原系統常見的「請選擇」）。 */
  placeholder?: string;
  /** 表單欄位名（批次 13：complexBody 頁的 C5-h 接線率掃描用 input[name]）。 */
  name?: string;
  /** DOM id（批次 14：report 頁 legacy 以 id 讀值的無 name 欄位）。 */
  id?: string;
  /** 批次 43（#41）：required 屬性鏡像（commonFormTemplate.jsp 查詢欄 required）。 */
  required?: boolean;
}

/**
 * select 的 disabled 底色與其他欄位不同：原系統另外覆寫成
 * `select[disabled] { background-color: rgb(235,235,228) }`（style-ePortfolio.css:14-16），
 * 不是 bootstrap 的 #eee。【雛形值待實機校準】
 */
const DISABLED_BG_CLASS = 'disabled:bg-[rgb(235,235,228)]';

/**
 * 下拉選單。
 *
 * ponytail: 用原生 `<select>`，不自製 dropdown。原系統用的是 select2／bootstrap-select
 * （外觀是加了搜尋框的自訂 popup），雛形先不還原那層 chrome —— 那是「可搜尋下拉」這個
 * 獨立元件的題目，塞進基礎 Select 會讓每個用不到搜尋的地方都扛著它。
 * 升級路徑：真的需要時在第二層另做 SearchableSelect，本元件維持原生語意不動。
 * 【雛形值待實機校準】：原系統下拉的實際尺寸來自 select2.css，本元件目前沿用 form-control。
 */
export function Select({
  uiId,
  value,
  onChange,
  options,
  disabled = false,
  invalid = false,
  placeholder,
  name,
  id,
  required,
}: SelectProps) {
  return (
    <select
      data-ui-id={uiId}
      {...(name === undefined ? {} : { name })}
      {...(id === undefined ? {} : { id })}
      {...(required === undefined ? {} : { required })}
      className={`${FIELD_BASE_CLASS} ${fieldBorderClass(invalid)} ${DISABLED_BG_CLASS}`}
      value={value}
      disabled={disabled}
      aria-invalid={invalid}
      onChange={(event) => onChange(event.target.value)}
    >
      {placeholder === undefined ? null : <option value="">{placeholder}</option>}
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
